var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareX = function SvgShareX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "shareX_svg__sc-gKsewC shareX_svg__fzJjte",
    "data-testid": "ShareIcon-x",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.559 12.251 9.266 12.923L11.5 35.678h2.1l8.163-9.199 6.596 9.2H35.5l-9.788-13.65 8.68-9.779h-2.099l-7.518 8.471-6.075-8.47zm3.086 1.612h3.28l14.488 20.203h-3.28z"
  })));
};
export default SvgShareX;